module.exports = "assets/c5f2855c60d843e2383f04e2024a3db4.jpeg";